import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { checkIsValidArray, DateUtility } from "../../helpers/commonFunction";
import { routes } from "../../helpers/constants";
import BackArrow from "../../components/BackArrow";
import { DataNotFound } from "../../components";
import { dataMessages } from "../../helpers/messages";

const ReportItemDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { selectedRestaurant, selectedItem, selectedLocation } =
    location?.state;

  const [selectedFilters, setSelectedFilters] = useState({
    itemName: "",
    date: "",
  });

  const hasAnyReport = useMemo(() => {
    return (
      Array.isArray(selectedItem?.sub_items) &&
      selectedItem.sub_items.some(
        (item) => Array.isArray(item.item_report) && item.item_report.length > 0
      )
    );
  }, [selectedItem]);

  const currentItemReport = useMemo(() => {
    if (!Array.isArray(selectedItem?.sub_items)) return [];

    const newSItem = [selectedItem];

    const data = newSItem.map((item) => {
      const firstReportDate =
        Array.isArray(item?.sub_items) &&
        item?.sub_items?.some((sub) => sub?.item_report?.length > 0)
          ? item?.sub_items?.find((sub) => sub?.item_report?.length > 0)
              ?.item_report[0]?.record_date
          : null;
      return {
        ...item,
        date: firstReportDate,
      };
    });

    return data;
  }, [selectedItem]);

  const itemOptions = [
    {
      value: selectedItem?.name,
      label: selectedItem?.name?.toUpperCase(),
    },
  ];

  const monthOptions = useMemo(() => {
    if (!Array.isArray(currentItemReport)) return [];

    const monthSet = new Set();
    currentItemReport.forEach((row) => {
      const date = new Date(row.date);

      const value = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;

      const label = date.toLocaleString("en-US", {
        month: "long",
        year: "numeric",
      });

      monthSet.add(JSON.stringify({ value, label }));
    });

    return Array.from(monthSet)
      .map((m) => JSON.parse(m))
      .sort((a, b) => a.value.localeCompare(b.value));
  }, [currentItemReport]);

  const handleFilters = (data, type) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [type]: data,
    }));
  };

  const filteredRows = useMemo(() => {
    let rows = [...currentItemReport];

    if (selectedFilters.itemName?.value) {
      rows = rows.filter(
        (row) => row.itemName === selectedFilters.itemName.value
      );
    }

    if (selectedFilters.date?.value !== undefined) {
      rows = rows.filter((row) => {
        const rowMonth = new Date(row.date).getMonth();
        const filteredMonth = new Date(selectedFilters.date.value).getMonth();
        return rowMonth === filteredMonth;
      });
    }
    return rows;
  }, [currentItemReport, selectedFilters]);

  return (
    <div className="tcl-raffles-makati-page tcl-report-item-detail-page">
      <BackArrow
        handleClick={() =>
          navigate(routes.companyItemList, { state: { ...location.state } })
        }
      />
      <div className="tcl-raffles-makati-wrapper">
        {hasAnyReport &&
          Array.isArray(selectedItem.sub_items) &&
          selectedItem.sub_items.length !== 0 && (
            <div className="tcl-report-item-tank my-3">
              <Select
                options={itemOptions}
                defaultValue={itemOptions[0]}
                // onChange={(data) => handleFilters(data, "itemName")}
                className="green-select"
                classNamePrefix="green-select"
                isSearchable={false}
              />
            </div>
          )}
        <div className="tcl-report-item-data-wrapper d-flex flex-column gap-2">
          {hasAnyReport && checkIsValidArray(selectedItem.sub_items) && (
            <Select
              options={monthOptions}
              defaultValue={monthOptions[0]}
              onChange={(data) => handleFilters(data, "date")}
              className="green-select w-55"
              classNamePrefix="green-select"
              isSearchable={false}
            />
          )}
          <div className="tcl-raffles-makati-table">
            {hasAnyReport && checkIsValidArray(selectedItem.sub_items) ? (
              <table className="items-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>ITEMS</th>
                    <th>Date</th>
                    <th>Day</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows.map((row, index) => (
                    <tr
                      key={`${row.itemId}-${row.reportId}`}
                      onClick={() => {
                        navigate(routes.companyReportStages, {
                          state: {
                            ...location?.state,
                            selectedRestaurant,
                            selectedItem,
                            selectedLocation,
                            // type: "REPORTS",
                          },
                        });
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{selectedItem.name}</td>
                      <td>{DateUtility.monthDayYear3(row.date)}</td>
                      <td>
                        {new Date(row.date).toLocaleDateString("en-US", {
                          weekday: "long",
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <DataNotFound name={dataMessages.noReports} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportItemDetails;
